// extracted by mini-css-extract-plugin
module.exports = {"main":"Drawer_main__1GCSF","title":"Drawer_title__1YepT","back":"Drawer_back__2qroR","show":"Drawer_show__RORWy"};